var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M127.644,120.001l-22.202,-25.97l37.412,-37.409l22.199,25.974l-37.409,37.405Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.969,91.69l-22.206,-25.974l37.404,-37.405l22.203,25.974l-37.401,37.405Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.29,63.378l-22.206,-25.97l37.404,-37.408l22.203,25.978l-37.401,37.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.823,152.8l-37.409,37.401l21.179,24.955l37.401,-37.401l-21.171,-24.955Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.011,210.256l-37.405,37.401l21.179,24.95l37.401,-37.392l-21.175,-24.959Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.634,180.247l-37.405,37.397l21.183,24.962l37.397,-37.408l-21.175,-24.951Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.843,132.517l-20.203,-31.048l-36.176,-25.338l-0.608,0.605l-60.82,60.82l0.003,-0l-0.6,0.597l20.206,31.055l36.18,25.331l60.812,-60.817l1.206,-1.205Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.396,192.411c-13.415,-12.501 -20.14,-28.885 -20.195,-45.301l-17.268,-0.004c0.058,20.532 8.462,41.052 25.245,56.673c16.792,15.625 38.82,23.455 60.867,23.505l0,-16.07c-17.621,-0.055 -35.23,-6.318 -48.649,-18.803Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.914,217.993c-20.997,-19.547 -31.505,-45.215 -31.559,-70.883l-17.264,-0.007c0.054,29.791 12.252,59.576 36.614,82.27c24.361,22.676 56.347,34.04 88.348,34.083l-0,-16.074c-27.583,-0.047 -55.142,-9.846 -76.139,-29.389Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.232,95.593l-41.983,40.699",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "7.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.338,103.83l-59.352,58.141",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "7.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.214,135.335l-41.982,40.699",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "7.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.076,242.606c-27.311,-25.784 -44.99,-61.634 -45.06,-95.503l-14.202,-0.609c0.07,39.304 15.939,78.596 47.63,108.539c31.687,29.912 73.301,44.913 114.931,44.967l-0,-15.442c-35.882,-0.059 -75.984,-16.168 -103.299,-41.952Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat);
export default __webpack_public_path__ + "static/media/sat.27d179d5.svg";
export { ForwardRef as ReactComponent };